import { cn } from "../lib/utils.js";

/**
 * Magenta wordmark with a rounded "73" chip — the numeric suffix shared with
 * cluster73 and lab73, worn like a badge instead of a plain label.
 *
 * On mount the chip draws its ring, then a checkmark ticks in ("reviewed"),
 * then settles into the plain "73" mark. With `loop`, the sequence repeats
 * (used for the app's initial-load splash, where duration is unknown).
 * Reduced-motion users see the settled state immediately either way.
 */
export function Logomark({ size = "sm", loop = false }: { size?: "sm" | "lg"; loop?: boolean }) {
  const box = size === "lg" ? "h-16 w-16" : "h-7 w-7";
  return (
    <div className="flex items-center gap-2">
      <span className={cn("relative flex items-center justify-center", box)}>
        <svg
          viewBox="0 0 28 28"
          className={cn(box, loop && "logomark--loop")}
          aria-hidden="true"
        >
          <circle cx="14" cy="14" r="13" fill="var(--primary)" className="logomark-ring" />
          <path
            d="M8.5 14.5l3.5 3.5 7.5-7.5"
            fill="none"
            stroke="var(--primary-foreground)"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="logomark-check"
          />
        </svg>
        <span
          className={cn(
            "logomark-digits absolute font-extrabold leading-none text-primary-foreground",
            size === "lg" ? "text-2xl" : "text-xs",
          )}
        >
          73
        </span>
      </span>
    </div>
  );
}
